import { serverUrl } from './serverConfig'
import { genericError } from "../util/errorUtil"
export const getSwingVideoUserSasApi = async (payload) => {
    try {
        const { playerUid, sessionToken } = payload
        const body = {
            "identity": "user.aca.getusersas",
            "uid": playerUid
        }
        const swingVideoUserSas = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await swingVideoUserSas.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}